const supportedLocales = {
    ua: 'укр',
    de: 'de',
};
export default supportedLocales;